$(document).ready(function () {
    let regexSendSuc = /\/home\/Mail\/Success/;
    let regexSendFail = /\/home\/Mail\/Failed/;
    let regexCancSuc = /\/home\/Request\/Cancelled/;
    let regexCancFail = /\/home\/Request\/Failed/;
    let regexChangeSuc = /\/home\/Wachtwoord\/Changed/;
    let regexChangeFail = /\/home\/Wachtwoord\/Failed/;
    let regexGDPRSuc = /\/home\/GDPR\/Failed/;
    let regexGDPRFail = /\/home\/GDPR\/Failed/;
    if (regexSendSuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Home', '/');
        $(".verz_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }
    if (regexCancSuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Home', '/');
        $(".canc_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }
    if (regexChangeSuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Home', '/');
        $(".save_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }
    if (regexSendFail.test(window.location.pathname) || regexCancFail.test(window.location.pathname) || regexChangeFail.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Home', '/');
        $(".save_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }
    if (regexGDPRSuc.test(window.location.pathname)) {
        console.log("Tester");
        window.history.replaceState({}, 'KBSV - Home', '/');
        $(".save_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }
    if (regexGDPRFail.test(window.location.pathname) || regexCancFail.test(window.location.pathname) || regexChangeFail.test(window.location.pathname)) {
        console.log("Tester");
        window.history.replaceState({}, 'KBSV - Home', '/');
        $(".save_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }
});



//////////////////
// WEBPACK FOOTER
// ./js/wijzigwachtwoord.js
// module id = 21
// module chunks = 0